const UPDATES = [
  {
    date: '2026-07-31',
    tag: '定档',
    title: '《流浪地球3》定档2026暑期，吴京刘德华再度联手拯救地球',
  },
  {
    date: '2026-07-30',
    tag: '开机',
    title: '《狂飙2》正式开机，张译张颂文原班人马回归引发期待',
  },
  {
    date: '2026-07-28',
    tag: '票房',
    title: '《封神第二部》票房突破40亿，创国产奇幻电影新纪录',
  },
  {
    date: '2026-07-26',
    tag: '上线',
    title: '《庆余年3》杀青在即，范闲终极篇章预计年底上线',
  },
  {
    date: '2026-07-24',
    tag: '官宣',
    title: '《哪吒之魔童闹海》续集正式官宣，2027年春节档上映',
  },
  {
    date: '2026-07-22',
    tag: '口碑',
    title: '《长相思》第二季豆瓣开分8.9，古装剧年度口碑之作来袭',
  },
  {
    date: '2026-07-20',
    tag: '热播',
    title: '《大江大河3》豆瓣9.2分热播中，再现改革开放时代经典',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500/15">
            <i className="ri-flashlight-line text-accent-400 text-lg"></i>
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              最新动态
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">
              影视圈实时快讯，追踪最热动态
            </p>
          </div>
        </div>

        <div className="relative pl-6 border-l-2 border-background-300/40">
          {UPDATES.map((item, idx) => (
            <div
              key={idx}
              className={`relative pb-8 last:pb-0 ${idx === 0 ? '' : ''}`}
            >
              <div className="absolute -left-[25px] top-0 w-4 h-4 rounded-full bg-background-50 border-2 border-accent-500/60 z-10"></div>
              <div className="ml-4">
                <span className="inline-block px-2.5 py-0.5 rounded-md text-xs font-medium bg-accent-500/15 text-accent-400 mb-2">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-600 ml-2">{item.date}</span>
                <h3 className="mt-1 text-sm md:text-base font-medium text-foreground-200 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}